import {GeomObject} from "./geom-object";
import {FreePointOnLine} from "../geom-relations/free-point-line";
import * as BABYLON from "babylonjs/babylon.max";

const SubLineTypes = {
    POINT: 1,
    SEGMENT: 2,
    RAY: 3,
    GENERAL: 4,
    VECTOR: 5,
    NULL_VECTOR:6
};


class Subline extends GeomObject {
    constructor (a, b, color) {
        if (arguments.length === 3) {
            if (!(a instanceof Point3 && b instanceof Point3)) {
                throw "Expecting two points.";
            }
            super(window.cabri.emsc.createSegment(a.objectId, b.objectId));
            this.a = a;
            this.b = b;
            this.color = color || "#7F7F7F"; // Color3.Gray in Babylon
        }
        else {
            super(a);
            this.color =
                this.curve_color1 =
                    super.getColorAttribute("curve_color1", "#7F7F7F");
            this.curve_radius =
                super.getFloatStyleAttribute("curve_radius", 1.0);
            this.coords = [0, 0, 0, 0, 0, 0];
        }
    }

    // style from curve_style, curve_radius
    // curve_color1

    createTube () {
        if (this.noDisplay || this.hidden) return;
        if (this.bSegment) {
            this.bSegment.dispose(false, true);
        }
        // TODO: use updateable tubes

        if (this.a && this.b)
            this.bSegment =
                BABYLON.MeshBuilder.CreateTube("Segment" + this.objectId,
                    {
                        path: [this.a.bPoint.position, this.b.bPoint.position],
                        radius: 0.05 * this.curve_radius,
                        tesselation: 8,  // default is 64
                    }, cabri.scene);
        else {
            const c  = this.coords, r = 10*cabri.camera.radius;
            const a = new BABYLON.Vector3(c[0],c[2], c[1]);
            const b = (this.type===SubLineTypes.SEGMENT)  ?
                new BABYLON.Vector3(c[3], c[5], c[4]) :
                (this.type===SubLineTypes.RAY) ?
                new BABYLON.Vector3(c[0] + r*c[3], c[2]+ r*c[5], c[1]+r*c[4])
                    : null;
            if ( b === null ) return;
            this.bSegment =
                BABYLON.MeshBuilder.CreateTube("Segment" + this.objectId,
                    {
                        path: [a, b],
                        radius: 0.05 * this.curve_radius,
                    },
                    cabri.scene);
            this.bSegment.cabriPeer = this;
        }
        super.markColor(this.bSegment, this.curve_color1);
        //this.registerHighlighter(this.bSegment);
    }

    highlight (active) {
        if (typeof (this.highlighted) === "undefined") {
            this.highlighted = false;
        }
        if (typeof (active) === "undefined") {
            active = !this.highlighted;
        }
        if (this.highlighted !== active) {
            this.highlightThisPeer(this.bSegment, active);
        }
        this.highlighted = active;
    }

    updateFromPeer () {
        if (this.alreadyCheckedInLastCycle) {
            return this.updatedInLastCycle;
        }
        this.alreadyCheckedInLastCycle = true;
        if (typeof (a) !== "undefined" && typeof (b) !== "undefined" && a &&
            b) {
            this.updatedInLastCycle =
                this.a.updateFromPeer() || this.b.updateFromPeer();
        }
        else {
            let coordsDE;
            try {
                let type = cabri.emsc.getSublineType(this.objectId);
                this.type = type;
                coordsDE = cabri.emsc.getAffineSegmentCoordinates(
                    this.objectId);
                if (this.coords) {
                    this.updatedInLastCycle = false;
                    for (let i = 0; i < 6; i++)
                        this.updatedInLastCycle =
                            this.updatedInLastCycle || this.coords[i] !== coordsDE[i];
                    if (this.updatedInLastCycle)
                        for (let i = 0; i < 6; i++) this.coords[i] = coordsDE[i];
                }
            } finally {
                if(coordsDE) cabri.emsc._free(coordsDE);
            }
        }
        if (this.updatedInLastCycle) {
            this.createTube();
        }
    }

    dispose () {
        if (this.bSegment) this.bSegment.dispose(false, true);
        super.dispose();
    }

    canBeRelatedWith (other) {
        return other && other.constructor.name === "Point";
    }

    createRelationWith ( other ) {
        return new FreePointOnLine(this, other);
    }
}




export {Subline};